import { TOAST_TYPE, USER_ROLE } from "Constants/constant";
import { roleAccess } from "helpers/RolesPermission";
import { call, put, takeLatest } from "redux-saga/effects";
import { generalActions } from "../actions";
import INCIDENT_ACTIONS from "../actions/incident.actions";
import api from "../services/incident.services";

// Action Creators
export const incidentActions = {
  // List
  getIncidentList: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_LIST.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_LIST.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_LIST.ERROR,
      error,
    }),
  },
  getIncidentListRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_LIST_CALL,
    payload,
  }),

  // Dashboard
  getIncidentDashboard: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_DASHBOARD.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_DASHBOARD.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_DASHBOARD.ERROR,
      error,
    }),
  },
  getIncidentDashboardRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_DASHBOARD_CALL,
    payload,
  }),

  // Detail
  getIncidentDetail: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_DETAIL.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_DETAIL.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_DETAIL.ERROR,
      error,
    }),
  },
  getIncidentDetailRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_DETAIL_CALL,
    payload,
  }),

  // Create
  createIncident: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_CREATE.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_CREATE.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_CREATE.ERROR,
      error,
    }),
  },
  createIncidentRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_CREATE_CALL,
    payload,
  }),

  // Update
  updateIncident: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_UPDATE.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_UPDATE.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_UPDATE.ERROR,
      error,
    }),
  },
  updateIncidentRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_UPDATE_CALL,
    payload,
  }),

  // Investigate
  investigateIncident: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_INVESTIGATE.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_INVESTIGATE.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_INVESTIGATE.ERROR,
      error,
    }),
  },
  investigateIncidentRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_INVESTIGATE_CALL,
    payload,
  }),

  // Close
  closeIncident: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_CLOSE.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_CLOSE.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_CLOSE.ERROR,
      error,
    }),
  },
  closeIncidentRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_CLOSE_CALL,
    payload,
  }),

  // Close Draft
  closeIncidentDraft: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT.ERROR,
      error,
    }),
  },
  closeIncidentDraftRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT_CALL,
    payload,
  }),

  // Delete
  deleteIncident: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_DELETE.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_DELETE.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_DELETE.ERROR,
      error,
    }),
  },
  deleteIncidentRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_DELETE_CALL,
    payload,
  }),

  // Export
  exportIncidents: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_EXPORT.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_EXPORT.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_EXPORT.ERROR,
      error,
    }),
  },
  exportIncidentsRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_EXPORT_CALL,
    payload,
  }),

  // Assigned Participants
  getAssignedParticipants: {
    pending: { type: INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS.ERROR,
      error,
    }),
  },
  getAssignedParticipantsRequest: () => ({
    type: INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS_REQUEST,
  }),

  // Bulk PDF Generate
  bulkGeneratePdf: {
    pending: { type: INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE.PENDING },
    success: (data) => ({
      type: INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE.SUCCESS,
      data,
    }),
    error: (error) => ({
      type: INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE.ERROR,
      error,
    }),
  },
  bulkGeneratePdfRequest: (payload) => ({
    type: INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE_CALL,
    payload,
  }),

  // Reset
  resetIncidentDetail: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_DETAIL,
  }),
  resetIncidentCreate: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_CREATE,
  }),
  resetIncidentDelete: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_DELETE,
  }),
  resetIncidentInvestigate: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_INVESTIGATE,
  }),
  resetIncidentClose: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_CLOSE,
  }),
  resetIncidentCloseDraft: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_CLOSE_DRAFT,
  }),
  resetBulkPdfGenerate: () => ({
    type: INCIDENT_ACTIONS.INCIDENT_RESET_BULK_PDF_GENERATE,
  }),
};

// Sagas
function* getIncidentListSaga(action) {
  try {
    yield put(incidentActions.getIncidentList.pending);
    const response = yield call(api.getIncidentList, action.payload);

    // Handle response with data (API returns { data: {...} } or { success: true, data: {...} })
    if (response && response.data) {
      yield put(incidentActions.getIncidentList.success(response.data));
    }
    // Handle error response
    else if (response && response.error) {
      yield put(incidentActions.getIncidentList.error(response.error));
    }
    // Handle unexpected response structure
    else {
      yield put(
        incidentActions.getIncidentList.error(
          response?.message || "Unexpected response format",
        ),
      );
    }
  } catch (error) {
    yield put(
      incidentActions.getIncidentList.error(
        error.message || "Failed to fetch incident list",
      ),
    );
  }
}

function* getIncidentDashboardSaga(action) {
  try {
    yield put(incidentActions.getIncidentDashboard.pending);
    const response = yield call(api.getIncidentDashboard, action.payload);

    // Handle response with data (API returns { data: {...} } or { success: true, data: {...} })
    if (response && response.data) {
      yield put(incidentActions.getIncidentDashboard.success(response.data));
    }
    // Handle error response
    else if (response && response.error) {
      yield put(incidentActions.getIncidentDashboard.error(response.error));
    }
    // Handle unexpected response structure
    else {
      yield put(
        incidentActions.getIncidentDashboard.error(
          response?.message || "Unexpected response format",
        ),
      );
    }
  } catch (error) {
    yield put(
      incidentActions.getIncidentDashboard.error(
        error.message || "Failed to fetch dashboard data",
      ),
    );
  }
}

function* getIncidentDetailSaga(action) {
  try {
    yield put(incidentActions.getIncidentDetail.pending);
    const payload =
      typeof action.payload === "string"
        ? { uuid: action.payload }
        : action.payload;
    const response = yield call(api.getIncidentDetail, payload);

    if (response && response.data) {
      yield put(incidentActions.getIncidentDetail.success(response.data));
    } else if (response && response.error) {
      yield put(incidentActions.getIncidentDetail.error(response.error));
    } else if (response && response.success) {
      yield put(incidentActions.getIncidentDetail.success(response.data || {}));
    } else {
      yield put(
        incidentActions.getIncidentDetail.error(
          response?.message || "Unexpected response format",
        ),
      );
    }
  } catch (error) {
    yield put(
      incidentActions.getIncidentDetail.error(
        error.message || "Failed to fetch incident detail",
      ),
    );
  }
}

function* createIncidentSaga(action) {
  try {
    yield put(incidentActions.createIncident.pending);
    const response = yield call(api.createIncident, action.payload);
    if (response && response.data) {
      yield put(incidentActions.createIncident.success(response.data));
      // Only show toast on final submission, not on step-by-step saves
      // Uncomment below if step-by-step toasts are needed in future
      // yield put(
      //   generalActions.showToast({
      //     type: TOAST_TYPE.SUCCESS,
      //     title: "Incident created successfully!",
      //   })
      // );
      // Show toast only for final submission
      if (response.data.status === "submitted") {
        yield put(
          generalActions.showToast({
            type: TOAST_TYPE.SUCCESS,
            title: "Incident report submitted successfully!",
          }),
        );
      }
    } else if (response && response.error) {
      yield put(incidentActions.createIncident.error(response.error));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.ERROR,
          title: response.error || "Failed to create incident",
        }),
      );
    }
  } catch (error) {
    yield put(incidentActions.createIncident.error(error.message));
  }
}

function* updateIncidentSaga(action) {
  try {
    yield put(incidentActions.updateIncident.pending);
    const { meta, ...apiPayload } = action.payload || {};
    const response = yield call(api.updateIncident, apiPayload);
    if (response && response.data) {
      yield put(incidentActions.updateIncident.success(response.data));
      // Only show toast on final submission, not on step-by-step saves
      // Uncomment below if step-by-step toasts are needed in future
      // yield put(
      //   generalActions.showToast({
      //     type: TOAST_TYPE.SUCCESS,
      //     title: "Incident updated successfully!",
      //   })
      // );
      // Show toast only for final submission
      const isFinalSubmit = meta?.isFinalSubmit === true;
      if (response.data.status === "submitted" && isFinalSubmit) {
        yield put(
          generalActions.showToast({
            type: TOAST_TYPE.SUCCESS,
            title: "Incident report submitted successfully!",
          }),
        );
      }
    } else if (response && response.error) {
      yield put(incidentActions.updateIncident.error(response.error));
    }
  } catch (error) {
    yield put(incidentActions.updateIncident.error(error.message));
  }
}

function* investigateIncidentSaga(action) {
  try {
    yield put(incidentActions.investigateIncident.pending);
    const response = yield call(api.investigateIncident, action.payload);
    if (response && response.data) {
      yield put(incidentActions.investigateIncident.success(response.data));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Investigation saved successfully!",
        }),
      );
    } else if (response && response.error) {
      yield put(incidentActions.investigateIncident.error(response.error));
    }
  } catch (error) {
    yield put(incidentActions.investigateIncident.error(error.message));
  }
}

function* closeIncidentSaga(action) {
  try {
    yield put(incidentActions.closeIncident.pending);
    const response = yield call(api.closeIncident, action.payload);
    if (response && response.data) {
      yield put(incidentActions.closeIncident.success(response.data));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Incident closed successfully!",
        }),
      );
    } else if (response && response.error) {
      yield put(incidentActions.closeIncident.error(response.error));
    }
  } catch (error) {
    yield put(incidentActions.closeIncident.error(error.message));
  }
}

function* closeIncidentDraftSaga(action) {
  try {
    yield put(incidentActions.closeIncidentDraft.pending);
    const response = yield call(api.closeIncidentDraft, action.payload);
    if (response && response.data) {
      yield put(incidentActions.closeIncidentDraft.success(response.data));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Close review draft saved successfully!",
        }),
      );
    } else if (response && response.error) {
      yield put(incidentActions.closeIncidentDraft.error(response.error));
    }
  } catch (error) {
    yield put(incidentActions.closeIncidentDraft.error(error.message));
  }
}

function* exportIncidentsSaga(action) {
  try {
    yield put(incidentActions.exportIncidents.pending);
    const response = yield call(api.exportIncidents, action.payload);
    if (response && response.data) {
      yield put(incidentActions.exportIncidents.success(response.data));
      // Handle file download
      if (response.data.url) {
        window.open(response.data.url, "_blank");
      }
    } else if (response && response.error) {
      yield put(incidentActions.exportIncidents.error(response.error));
    }
  } catch (error) {
    yield put(incidentActions.exportIncidents.error(error.message));
  }
}

function* fetchAllSpParticipants() {
  const PER_PAGE = 500;
  let page = 1;
  let allParticipants = [];
  let lastPage = 1;

  do {
    const response = yield call(api.getAllParticipants, {
      filters: {
        page,
        per_page: PER_PAGE,
        search: "",
        sort_order: "desc",
        sort_field: "created_at",
      },
      bodyFilter: null,
    });

    if (!response?.data) {
      break;
    }

    const participantPayload = response.data?.participant;
    const participants = participantPayload?.data || [];
    allParticipants = allParticipants.concat(participants);
    lastPage =
      participantPayload?.total_pages || participantPayload?.last_page || page;
    page += 1;
  } while (page <= lastPage);

  return allParticipants;
}

function* getAssignedParticipantsSaga() {
  try {
    yield put(incidentActions.getAssignedParticipants.pending);

    // Check user role to determine which endpoint to call
    const isAdminOrManager = roleAccess([
      USER_ROLE.Sp_Admin,
      USER_ROLE.Sp_manager,
    ]);

    let response;
    let normalizedData = null;

    if (isAdminOrManager) {
      // SP Admin/Manager: fetch all participants across pages
      const participants = yield call(fetchAllSpParticipants);
      normalizedData = { data: participants };
    } else {
      // Worker: Get assigned participants only
      response = yield call(api.getAssignedParticipants);

      if (response && response.status === 200 && response.data) {
        // Worker participants response structure: response.data.data
        const participants = response.data?.data || [];
        // Normalize to same format: { data: [...] }
        normalizedData = { data: participants };
      }
    }

    if (normalizedData) {
      yield put(
        incidentActions.getAssignedParticipants.success(normalizedData),
      );
    } else if (response && response.error) {
      yield put(incidentActions.getAssignedParticipants.error(response.error));
    } else {
      yield put(
        incidentActions.getAssignedParticipants.error(
          "Failed to fetch participants",
        ),
      );
    }
  } catch (error) {
    yield put(
      incidentActions.getAssignedParticipants.error(
        error.message || "Failed to fetch participants",
      ),
    );
  }
}

function* deleteIncidentSaga(action) {
  try {
    yield put(incidentActions.deleteIncident.pending);
    const response = yield call(api.deleteIncident, action.payload);
    if (response && (response.data || response.success)) {
      yield put(incidentActions.deleteIncident.success(response.data || {}));
    } else if (response && response.error) {
      yield put(incidentActions.deleteIncident.error(response.error));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.ERROR,
          title: response.error || "Failed to delete incident",
        }),
      );
    }
  } catch (error) {
    yield put(incidentActions.deleteIncident.error(error.message));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message || "Failed to delete incident",
      }),
    );
  }
}

function* bulkGeneratePdfSaga(action) {
  try {
    yield put(incidentActions.bulkGeneratePdf.pending);
    const response = yield call(api.bulkGeneratePdf, action.payload);
    if (response && response.data) {
      yield put(incidentActions.bulkGeneratePdf.success(response.data));
      const { generated = [], already_existed = [] } = response.data;
      if (already_existed.length > 0) {
        const n = already_existed.length;
        const msg =
          n === 1
            ? "1 report was already available. Select the PDF icon to download."
            : `${n} reports were already available. Select the PDF icon to download.`;
        yield put(
          generalActions.showToast({
            type: TOAST_TYPE.INFO,
            title: msg,
          }),
        );
      }
      if (generated.length > 0) {
        const n = generated.length;
        const msg =
          n === 1
            ? "1 report is ready to download"
            : `${n} reports are ready to download`;
        yield put(
          generalActions.showToast({
            type: TOAST_TYPE.SUCCESS,
            title: msg,
          }),
        );
      }
    } else if (response && response.error) {
      yield put(incidentActions.bulkGeneratePdf.error(response.error));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.ERROR,
          title: "Could not generate reports. Try again or contact support.",
        }),
      );
    }
  } catch (error) {
    yield put(incidentActions.bulkGeneratePdf.error(error.message));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: "Could not generate reports. Try again or contact support.",
      }),
    );
  }
}

// Watcher
export default function* incidentSaga() {
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_LIST_CALL, getIncidentListSaga);
  yield takeLatest(
    INCIDENT_ACTIONS.INCIDENT_DASHBOARD_CALL,
    getIncidentDashboardSaga,
  );
  yield takeLatest(
    INCIDENT_ACTIONS.INCIDENT_DETAIL_CALL,
    getIncidentDetailSaga,
  );
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_CREATE_CALL, createIncidentSaga);
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_UPDATE_CALL, updateIncidentSaga);
  yield takeLatest(
    INCIDENT_ACTIONS.INCIDENT_INVESTIGATE_CALL,
    investigateIncidentSaga,
  );
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_CLOSE_CALL, closeIncidentSaga);
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT_CALL, closeIncidentDraftSaga);
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_DELETE_CALL, deleteIncidentSaga);
  yield takeLatest(INCIDENT_ACTIONS.INCIDENT_EXPORT_CALL, exportIncidentsSaga);
  yield takeLatest(
    INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS_REQUEST,
    getAssignedParticipantsSaga,
  );
  yield takeLatest(
    INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE_CALL,
    bulkGeneratePdfSaga,
  );
}
